import { Container } from "@mui/material";
import CreateEventForm from '../components/forms/CreateEventForm';
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { BreadcrumbList,Box, Typography, Paragraph} from '@okta/odyssey-react-mui';
import { HomeIcon } from "@okta/odyssey-react-mui/icons";
import { useTranslation } from "react-i18next";

const CreateEvent = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();

    return (
        <Container className='AppContent'>
            <BreadcrumbList>
                <RouterLink to='/'><HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" /></RouterLink>
                <RouterLink to='/events'>Event Management</RouterLink>
                <Paragraph href="">Create event</Paragraph>
            </BreadcrumbList>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.285rem'}}>
                <Typography variant="h1">
                    {t('createForm-title',{ns:'events'})}
                    <Typography variant="support">{t('createForm-description',{ns:'events'})}</Typography>
                </Typography>
            </Box>
            <CreateEventForm labId={searchParams.get('labId')}/>
        </Container>
    );
};

export default CreateEvent;